module.exports = __webpack_public_path__ + "static/img/渠道-5.74efc358.png";